<ng-image-slider 
[images]="imageObject"
[infinite]="true"
[slideImage]="1"
[imageSize]="imageSize"
[autoSlide]="autoSlide"
 #nav></ng-image-slider>